module.exports = __webpack_public_path__ + "4e3ac3bf77f9b750817cc6fcfa08bd5a.png";